export { default as Allocation } from './common/Allocation'
export { default as Chart } from './common/Chart'
export { default as Dropdown } from './common/Dropdown'
export {
  default as DropdownWithCustomInput,
} from './common/DropdownWithCustomInput'
export { default as ErrorBoundary } from './common/ErrorBoundary'
export { default as Goal } from './common/Goal'
export { default as Icon } from './common/Icon'
export { default as Modal } from './common/Modal'
export { default as Number } from './common/Number'
export { default as Slider } from './common/Slider'
export { default as Title } from './common/Title'
export { default as Checkbox } from './common/Checkbox'

export { default as Education } from './forms/Education'
export { default as Freedom } from './forms/Freedom'
export { default as Holidays } from './forms/Holidays'
export { default as Profile } from './forms/Profile'
export { default as Purchase } from './forms/Purchase'
export { default as Retirement } from './forms/Retirement'

export { default as Allocations } from './layout/Allocations'
export { default as Edit } from './layout/Edit'
export { default as EditProfile } from './layout/EditProfile'
export { default as Empty } from './layout/Empty'
export { default as Goalpath } from './layout/Goalpath'
export { default as Header } from './layout/Header'
export { default as Planpath } from './layout/Planpath'
export { default as Sidebar } from './layout/Sidebar'
export { default as Summary } from './layout/Summary'

export { default as Clear } from './modals/Clear'
export { default as Delete } from './modals/Delete'
export { default as New } from './modals/New'
export { default as Share } from './modals/Share'
export { default as Email } from './modals/Email'
export { default as Templates } from './modals/Templates'
export { default as SaveDraft } from './modals/SaveDraft'



// WEBPACK FOOTER //
// ./src/components/index.js